import React from 'react'
import { Tag, Tooltip } from 'antd'

export const AlternativesTag: React.FC = () => {
  return (
    <Tooltip title="The selected item in this alternatives group will be highlighted for the client and count towards the document total.">
      <Tag color="orange">Contains Alternatives</Tag>
    </Tooltip>
  )
}
